import FetchService from "./Shared/FetchService";
const BASE_URL = "/aviso/institution";
export default class InstitutionService {
    static getTermToRepresentAdvisor() {
        return FetchService.get(BASE_URL + "/getTermToRepresentAdvisor");
    }
    static getTermToRepresentCoach() {
        return FetchService.get(BASE_URL + "/getTermToRepresentCoach");
    }
    static getStartScreenImage() {
        return FetchService.getSingleResponse(BASE_URL + "/getJumbotronImage");
    }
    static getApplicationTitle() {
        return FetchService.getSingleResponse(BASE_URL + "/getApplicationTitle");
    }
    static getInstitutionAcronym() {
        return FetchService.getSingleResponse(BASE_URL + "/getInstitutionAcronym");
    }
}
